import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { applySavedTheme } from '@rydres/ui';
import { App } from './App.js';
import './index.css';

applySavedTheme();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
